import React from 'react';
import './section-title.styles.scss';

function SectionTitle({ title }) {
  return <h2 className="section-title">{title}</h2>;
}

export default SectionTitle;
